const showJoinModal = () => {
  document
    ?.getElementById("join-dropdown-container")
    ?.classList.remove("dropdown-hidden");
  document
    ?.getElementById("background-overlay")
    ?.classList.remove("overlay-hidden");
};

const hideJoinModal = (event: MouseEvent) => {
  const target = event.target as HTMLTextAreaElement;

  if (target.id === "background-overlay") {
    document
      ?.getElementById("join-dropdown-container")
      ?.classList.add("dropdown-hidden");
    document
      ?.getElementById("background-overlay")
      ?.classList.add("overlay-hidden");
  }
};

const currentHeaderButton = document.getElementById("hero-header-link-button");

const newHeaderButton = document.createElement("a");
newHeaderButton.innerHTML = currentHeaderButton?.innerText || "";
newHeaderButton.className = "button button-red lg-margin-vertical-x-large";
newHeaderButton.id = "hero-header-link-button";
newHeaderButton.onclick = showJoinModal;

const backgroundOverlay = document.getElementById("background-overlay");
if (backgroundOverlay) {
  backgroundOverlay.onclick = hideJoinModal;
}

const headerButtonParent = currentHeaderButton?.parentNode;
if (headerButtonParent && currentHeaderButton) {
  headerButtonParent.replaceChild(newHeaderButton, currentHeaderButton);
}
